(function () {
  function initScrollStories() {
    const stories = document.querySelectorAll('[data-scroll-story]');

    stories.forEach((story) => {
      if (story.dataset.scrollStoryInitialized === 'true') return;

      story.dataset.scrollStoryInitialized = 'true';

      const triggers = story.querySelectorAll(
        '[data-scroll-story-trigger]'
      );

      const items = story.querySelectorAll(
        '[data-scroll-story-item]'
      );

      if (!triggers.length || !items.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const index = Number(entry.target.dataset.index);

            items.forEach((item, itemIndex) => {
              item.classList.toggle(
                'is-active',
                itemIndex === index
              );
            });
          });
        },
        {
          threshold: 0,
          rootMargin: '-40% 0px -40% 0px'
        }
      );

      triggers.forEach((trigger) => {
        observer.observe(trigger);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initScrollStories
    );
  } else {
    initScrollStories();
  }

  /*
   * Shopify Theme Editor support
   */
  document.addEventListener(
    'shopify:section:load',
    initScrollStories
  );
})();


// -------------media-scroll-cards-------------------
function initMediaScrollCards() {
    const sections = document.querySelectorAll('[data-media-scroll-cards]');

    sections.forEach((section) => {
      if (section.dataset.mediaScrollCardsInitialized === 'true') return;
      section.dataset.mediaScrollCardsInitialized = 'true';

      const pinWrap = section.querySelector('[data-scroll-cards-pin-wrap]');
      const track   = section.querySelector('[data-scroll-cards-track]');
      if (!pinWrap || !track) return;

      // The theme's ".section" wrapper (parent of .media-scroll-cards) is what actually
      // pins (position: sticky), not .media-scroll-cards itself. Its scroll runway has to
      // live on a non-sticky ancestor (the outer <section>) so it has room to stay stuck.
      const stickyEl = section.parentElement;
      const outer    = stickyEl.parentElement || stickyEl;

      function getScrollAmount() {
        return Math.max(0, track.scrollWidth - pinWrap.clientWidth);
      }

      function getHeaderHeight() {
        // theme's sticky header exposes its live height via this custom property
        const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        return parseFloat(raw) || 0;
      }

      function setup() {
        // set height synchronously so the onScroll call right after sees the real height, not a stale/zero one
        outer.style.height = (stickyEl.offsetHeight + getScrollAmount()) + 'px';
      }

      function onScroll() {
        const scrollAmount = getScrollAmount();
        if (scrollAmount <= 0) {
          // track already fits the pin-wrap — nothing to scroll
          track.style.transform = 'translateX(0)';
          return;
        }

        const headerH = getHeaderHeight();
        const rect    = outer.getBoundingClientRect();

        // CSS `position: sticky` on the .section wrapper does the actual pinning (as one
        // unit, title included). This only tracks how far past the pin point the user has
        // scrolled, to drive the cards' horizontal translation.
        const scrolled = Math.max(0, headerH - rect.top);
        const progress = Math.min(scrolled / scrollAmount, 1);
        track.style.transform = `translateX(-${progress * scrollAmount}px)`;
      }

      setup();
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => { setup(); onScroll(); });
      // intro height can shift once images/fonts finish loading — recalc once everything settles
      window.addEventListener('load', () => { setup(); onScroll(); });
    });
  }

document.addEventListener('DOMContentLoaded', initMediaScrollCards);

/* =========================================================
   SCROLL WORD MERGE
   ========================================================= */

(function () {

  function initScrollWordSections() {
    const sections = document.querySelectorAll(
      '[data-scroll-word-section]'
    );
    if (!sections.length) return;
    sections.forEach((section) => {
      if (section.dataset.scrollWordInitialized === 'true') {
        return;
      }
      section.dataset.scrollWordInitialized = 'true';
      const words = Array.from(
        section.querySelectorAll(
          '.scroll-word-section__word-wrapper'
        )
      );
      if (!words.length) return;
      function updateWords() {
        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const scrollDistance = Math.max(
          section.offsetHeight - viewportHeight,
          1
        );
        const scrolled = Math.min(
          Math.max(-rect.top, 0),
          scrollDistance
        );
        const progress =
          scrolled / scrollDistance;
        const wordCount = words.length;
        const step = 1 / wordCount;
        words.forEach((word, index) => {
          const start = index * step;
          const end = (index + 1) * step;
          let localProgress =
            (progress - start) /
            (end - start);
          localProgress = Math.max(
            0,
            Math.min(1, localProgress)
          );
          const enterEnd = 0.25;
          let enterProgress =
            localProgress / enterEnd;
          enterProgress = Math.max(
            0,
            Math.min(1, enterProgress)
          );
          const exitStart = 0.55;
          let exitProgress = 0;
          if (localProgress > exitStart) {

            exitProgress =
              (localProgress - exitStart) /
              (1 - exitStart);

          }
          exitProgress = Math.max(
            0,
            Math.min(1, exitProgress)
          );      
          const scaleIn =
            0.92 +
            (enterProgress * 0.08);
          const scaleOut =
            1 +
            (exitProgress * 0.12);
          const scale =
            scaleIn * scaleOut;
          let opacity = enterProgress;
          if (localProgress > exitStart) {
            opacity =
              1 - exitProgress;
          }       
          let y = 25 * (1 - enterProgress);
          if (localProgress > exitStart) {
            y =
              -15 * exitProgress;
          }
          word.style.opacity = opacity;
          word.style.transform =
            `translate(-50%, calc(-50% + ${y}px)) scale(${scale})`;
          if (
            localProgress > 0 &&
            localProgress < 1
          ) {
            word.style.zIndex = 10;
          } else {
            word.style.zIndex = 1;
          }

        });
      }
      let ticking = false;
      function requestUpdate() {
        if (ticking) return;
        window.requestAnimationFrame(() => {
          updateWords();
          ticking = false;
        });
        ticking = true;
      }
      window.addEventListener(
        'scroll',
        requestUpdate,
        { passive: true }
      );
      window.addEventListener(
        'resize',
        requestUpdate
      );
      updateWords();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initScrollWordSections
    );

  } else {
    initScrollWordSections();
  }


  /*
   * Shopify Theme Editor support.
   */

  document.addEventListener(
    'shopify:section:load',
    function () {

      initScrollWordSections();

    }
  );

})();
// =========about us js======
(function(){
  document.documentElement.classList.add('gravl-reveal-ready');
  function initGravlReveal(){
    const items = document.querySelectorAll(
      '.gravl-text-reveal:not([data-reveal-init])'
    );

    items.forEach(function(item){
      item.setAttribute('data-reveal-init','true');

      const observer = new IntersectionObserver(
        function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold:0.05,
          rootMargin:'0px 0px -5% 0px'
        }
      );
      observer.observe(item);
    });
  }

  if(document.readyState === 'loading'){

    document.addEventListener(
      'DOMContentLoaded',
      initGravlReveal
    );
  }else{
    initGravlReveal();
  }

  window.addEventListener(
    'load',
    initGravlReveal
  );

  document.addEventListener(
    'shopify:section:load',
    initGravlReveal
  );

})();


// ===== star rating product page clickable

document.addEventListener('click', function (event) {
  const rating = event.target.closest(
    '.product-info__rating .rating, .rating-with-text .rating'
  );

  if (!rating) return;

  const reviews = document.querySelector(
    '#judgeme_product_reviews, .jdgm-rev-widg, #shopify-product-reviews'
  );

  if (!reviews) return;

  event.preventDefault();

  reviews.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});